import { v4 as uuidv4 } from 'uuid';

export function ResponsiveLayoutMobile(props = {}, childrenComponents = []) {
	return {
		componentName: 'ResponsiveLayoutMobile',
		componentId: uuidv4(),
		props,
		childrenComponents,
	};
}
